<template>
  <div class="containerSetUpModal">
    <a-modal
      :visible="visible"
      title="配置"
      width="640px"
      @cancel="cancel"
      @ok="confirm(selected)"
    >
      <div class="title">我的材料库</div>
      <div class="box">
        <div @click="checkClick('on')" :style="{border: selected === 'on' ? '1px solid rgba(22,119,255,1)' : 'none' }" class="boxSelect">
          <div class="iconBox">
            <a-icon style="font-size: 50px;" :component="IconOpen" />
          </div>
          <div>
            <div class="titleName">开启</div>
            <div class="titleDescription">开启我的材料库</div>
          </div>
          <div v-if="selected === 'on'" class="checkIcon">
            <img width="43px" height="36px" src="@/assets/IconCheck.png" alt="">
          </div>
        </div>
        <div @click="checkClick('off')" :style="{border: selected === 'off' ? '1px solid rgba(22,119,255,1)' : 'none' }" class="boxSelect">
          <div class="iconBox">
            <a-icon style="font-size: 50px;" :component="IconClose" />
          </div>
          <div>
            <div class="titleName">关闭</div>
            <div class="titleDescription">关闭后材料将会被清空</div>
          </div>
          <div v-if="selected === 'off'" class="checkIcon">
            <img width="43px" height="36px" src="@/assets/IconCheck.png" alt="">
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import IconOpen from '@/assets/IconOpen.svg?inline'
import IconClose from '@/assets/IconClose.svg?inline'
import IconCheck from '@/assets/IconCheck.svg?inline'
import IconCheckPng from '@/assets/IconCheck.png'
import { jiopAPI } from '@/api/jiopweb/jiop'
export default {
  name: 'SetUpModal',
  data () {
    return {
      IconOpen,
      IconClose,
      IconCheck,
      IconCheckPng,
      visible: false,
      selected: 'on',
      stateValue: ''
    }
  },
  created () {
    this.materialManagerState()
  },
  methods: {
    materialManagerState () {
      const data = {
        appType: '1',
        userId: ''
      }
      jiopAPI.materialManagerState(data).then(res => {
        if (res.success) {
          this.stateValue = res.data.data
          this.selected = res.data.data
          this.$emit('getState', this.selected)
        }
      })
    },
    open () {
      this.selected = this.stateValue
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    confirm (state) {
      const data = {
        state: state,
        appType: '1',
        userId: ''
      }
      jiopAPI.changeMaterialManagerState(data).then(res => {
        if (res.success) {
          if (state === 'on') {
            localStorage.setItem('NO_WARN', 'yes')
          }
          this.stateValue = this.selected
          this.$emit('getState', this.selected)
          this.visible = false
          this.$parent.getList()
        }
      })
    },
    checkClick (value) {
      this.selected = value
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 16px;
  color: #333333;
  line-height: 26px;
  font-weight: 400;
  margin-bottom: 12px;
  margin-top: 6px;
}
.box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 43px;
}
.boxSelect {
  position: relative;
  cursor: pointer;
  width: 280px;
  height: 110px;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 0px rgba(153,153,153,0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
}
.titleName {
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
  margin-bottom: 8px;
}
.titleDescription {
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
}
.iconBox {
  margin-left: 30px;
  margin-right: 21px;
}
.checkIcon {
  position: absolute;
  bottom: 0px;
  right: 0px;
}
</style>
